export const WHATSAPP_PHONE = "5577987654321";

export const INSTAGRAM_LINK = "https://www.instagram.com/overx_br/?igsh=MWR0NDd3MHA2cWl4Yg%3D%3D";
export const LINKEDIN_LINK = "https://www.linkedin.com/in/over-x-734a0a306/";
export const SITE_LINK = "https://overxbrasil.com.br/";